export default function Marquee() {
  const items = [
    "Brand Amplification Company",
    "Media Infrastructure",
    "Integrated Ecosystem",
    "Owned Attention",
    "XMLOOPS · TV Network",
    "India's First",
  ];
  const row = items.concat(items);

  return (
    <section
      className="relative py-16 md:py-24 border-y border-white/5 overflow-hidden"
      data-testid="marquee-section"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap marquee-track will-change-transform">
        {row.concat(row).map((t, i) => (
          <div key={i} className="flex items-center gap-10 pr-10">
            <span className="font-display outline-text text-[10vw] md:text-[7vw] leading-none tracking-tight">
              {t}
            </span>
            <span className="w-3 h-3 rounded-full bg-[#e63946] shrink-0 shadow-[0_0_20px_#e63946]" />
          </div>
        ))}
      </div>
    </section>
  );
}
